import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import { InvoiceService } from "../../../invoice.service";
import { IInvoice } from "../../../interfaces/invoice.interface";
import { ICustomer } from "../../../../customer/customer.interface";
import { CustomerService } from "../../../../customer/customer.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ListService } from "../../../../../auth/service/list.service";
import { ProductsService } from "../../../../products/products.service";
import moment from "moment/moment";

@Component({
  selector: "app-invoice-to-send",
  templateUrl: "./invoice-generated.component.html"
})
export class InvoiceGeneratedComponent implements OnInit {
  tableLimit: number = 10;
  searchKeyword: string = "";
  contentHeader: IContentHeader;
  listElements: any[] = [];
  filteredListElements: any[] = [];
  filterCustomer: { id: number; name: string; } = { id: null, name: null };
  filterInvoiceType: { id: number; name: string; } = { id: null, name: null };
  idsToSend: number[] = [];
  customers: ICustomer[] = [];
  sendingToEsolver: boolean = false;
  multiToggle: boolean = false;
  rows_types: any = [];
  invoice_document_types: any = [];
  payment_terms: any = [];
  sumTotalsAmount: number = 0;
  credit_notes_types_ids = [];
  checkProductsList = false;

  filterYear: number = moment().year();
  years = Array.from({ length: this.filterYear - 2024 + 2 }, (v, i) => 2024 + i);

  filterMonth: number = -1;
  months = moment.months();

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _invoiceService: InvoiceService,
    private _customerService: CustomerService,
    public _modalService: NgbModal,
    private _listService: ListService,
    public _userService: UserService,
    public _productService: ProductsService
  ) {
    this.contentHeader = {
      headerTitle: "MENU.INVOICES_GENERATED",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.INVOICES",
            isLink: false
          },
          {
            name: "MENU.INVOICES_GENERATED",
            isLink: false
          }
        ]
      }
    };

    this._utilService.disableAutoHideLoading();
    this._listService.getList("invoice_document_type").then((result: any) => {
      this.invoice_document_types = result;
      this.credit_notes_types_ids = result.filter((result: any) => result.other.credit_note).map((result: any) => result.id);
    });


    if (!this.checkProductsList && this._productService.productsList.length < 1) {
      this.checkProductsList = true;
      this._productService.getProductsList().then((results: any) => {
        this._productService.productsList = results;
      });
    }

  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_invoice_generated")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.customers = await this._customerService.getCustomers();
    this.load();
  }

  load() {
    this._utilService.showLoading();
    this._invoiceService.getToSend().subscribe((invoices) => {
      invoices = invoices.map((invoice: any) => {

        if (invoice.additional_data.length) {
          const additional_data: any = this._invoiceService.explodeAdditionalData(invoice.additional_data);
          invoice.order_number = additional_data.IdDocumento;
        } else {
          invoice.order_number = invoice.id;
        }

        invoice.is_credit_note = invoice.invoice_type.name.toLowerCase().includes('nota di credito')

        return invoice;
      });
      this.listElements = invoices;
      this.filter();
      this._utilService.hideLoading();
    });
  }

  filter() {
    let items: any[] = this.listElements;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) =>
        (item.document_number || "").toLowerCase().includes(keywords) ||
        (item.order_number || "").toLowerCase().includes(keywords) ||
        (item.client && item.client.name && item.client.name.toLowerCase().includes(keywords)) ||
        (item.users_in_rows || []).join(",").toLowerCase().includes(keywords) ||
        (item.products_in_rows || []).join(",").toLowerCase().includes(keywords) ||
        (item.rows || [])[0]?.description?.toLowerCase().includes(keywords) || Number(keywords) === Number(item.id)
      );
    }

    const month = Number(this.filterMonth);
    if (month > -1) {
      items = items.filter((item: any) => moment(item.document_date).month() === month);
    }

    const year = Number(this.filterYear);
    if (year > 0) {
      items = items.filter((item: any) => moment(item.document_date).year() === year);
    }

    if (!!this.filterCustomer?.id) {
      const customer_id = Number(this.filterCustomer.id);
      items = items.filter((item) => Number(item.client.id) === customer_id);
    }

    if (!!this.filterInvoiceType?.id) {
      const type_id = Number(this.filterInvoiceType.id);
      items = items.filter((item) => Number(item.invoice_type.id) === type_id);
    }

    const invoicesAmount = items
      .filter((item: any) => !this.credit_notes_types_ids.includes(item.invoice_type.id))
      .map((item: any) => Number(item.total_amount)).reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

    const creditNotesAmount = items
      .filter((item: any) => this.credit_notes_types_ids.includes(item.invoice_type.id))
      .map((item: any) => Number(item.total_amount)).reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

    this.idsToSend = [];
    this.sumTotalsAmount = invoicesAmount - creditNotesAmount;
    this.filteredListElements = items;
  }

  modalOpen(event: any, modal: TemplateRef<any>, toEsolver: boolean) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.sendingToEsolver = toEsolver;
    this._modalService.open(modal, {
      size: "md",
      centered: true
    });
  }

  modalClose() {
    this.sendingToEsolver = false;
    this._modalService.dismissAll();
  }

  toggleInvoice(checked: boolean, invoice: IInvoice) {
    if (checked) {
      this.idsToSend.push(invoice.id as number);
    } else {
      this.idsToSend = this.idsToSend.filter((i: number) => i !== invoice.id);
    }
  }

  multiToggleInvoice(checked: boolean) {
    this.multiToggle = checked;
    if (this.multiToggle) {
      this.filteredListElements.map((element) => {
        if (element.has_client_approval) {
          this.idsToSend.push(element.id as number);
        }
      });
      if (this.idsToSend.length === 0) {
        this.multiToggle = !checked;
      }
    } else {
      this.idsToSend = [];
    }
  }

  async updateStatus() {
    if (!this._authenticationService.hasCapability("send_invoice")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let status = "success";
    let messageOk = "INVOICES_SENT_SUCCESSFULLY";
    let messageKo = "ERROR_SENDING_INVOICES";

    if (this.sendingToEsolver) {
      status = "processing";
      messageOk = "INVOICES_SENT_SUCCESSFULLY_TO_ESOLVER";
      messageKo = "ERROR_SENDING_INVOICES_TO_ESOLVER";
    }

    this._utilService.showLoading();
    this._invoiceService.updateStatus(this.idsToSend, status).subscribe((data: any) => {
      this._utilService.hideLoading();
      this.modalClose();
      if (!data.error) {
        this.idsToSend = [];
        this.load();
        this._utilService.showToastrSuccess(messageOk);
      } else {
        this._utilService.showToastrError(data.message || messageKo);
      }
    });
  }

  async deleteInvoice(invoice: any) {
    if (!this._authenticationService.hasCapability("delete_invoice")) {
      window.history.back();
      return false;
    }
    const additional_data: any = {};
    if (!!invoice.additional_data && invoice.additional_data.length) {
      const parts = invoice.additional_data.split(";");
      if (parts.length) {
        parts.forEach(part => {
          const [_, key, value] = part.match(/\[DatiOrdineAcquisto\|(\w+)\|([^\]]+)]/);
          additional_data[key] = value === "null" ? null : value;
        });
      }
    }

    await this._utilService.translate("ALERT.CONFIRM_DELETE_INVOICE")
      .then(async (text: string) => {
        await this._utilService.showSWALDeleteConfirmation({ text: text.replace("ORDER_NUMBER", additional_data.IdDocumento || "") })
          .then((res: any) => {
            if (res.isConfirmed) {
              this._invoiceService.delete(invoice.id)
                .subscribe((result: any) => {
                  if (!result.error) {
                    this.listElements = this.listElements.filter((elem: any) => Number(elem.id) !== Number(invoice.id));
                    this.filter();
                  }
                });
            } else {
              this._utilService.showSWALError({ title: "ABORTED_TITLE", text: "ABORTED_TEXT" });
            }
          });
      });


  }
}
